import { H3 } from '@/common/ui'
import { DIALOG_COPY } from '@/locales/en'
import { CircleAlertIcon } from 'lucide-react'
import { FC } from 'react'

type Props = {
    className?: string
    swiftIdOnboarding?: boolean
}

export const NoTradingAccountAlert: FC<Props> = ({ className, swiftIdOnboarding }) => (
    <div className={`flex flex-col gap-4 mb-10 ${className}`}>
        <div className="flex items-center gap-4 mb-4">
            <CircleAlertIcon size={40} />
            <H3 className="mb-0 md:text-2xl">{DIALOG_COPY.noTradingAccount.title}</H3>
        </div>
        <p>
            {swiftIdOnboarding
                ? DIALOG_COPY.noTradingAccount.swiftIdDescription
                : DIALOG_COPY.noTradingAccount.description}
        </p>
    </div>
)
